import { getBridge } from "../bridge";

// A stable per-device identifier. Prefer a real hardware id from the native
// shell so a reinstall re-claims the same device instead of orphaning it;
// otherwise generate and persist one in secure storage.

const FINGERPRINT_KEY = "gocityscreens.device.fingerprint";

function randomId(): string {
  try {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
      return crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  return `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function getFingerprint(): Promise<string> {
  const bridge = getBridge();

  const hardware = await bridge.getHardwareFingerprint();
  if (hardware) {
    await bridge.secureStore.set(FINGERPRINT_KEY, hardware);
    return hardware;
  }

  const stored = await bridge.secureStore.get(FINGERPRINT_KEY);
  if (stored) return stored;

  const generated = randomId();
  await bridge.secureStore.set(FINGERPRINT_KEY, generated);
  return generated;
}
